import K from '../constants';
import restHelpers from '../helpers/restHelper';

export default {
  getAll: () => restHelpers.withBearer.get(`${K.API_URL}/drivers`, {}),
  create: (data) => restHelpers.withBearer.post(`${K.API_URL}/drivers`, { data: { ...data } }),
  update: (uin, data) => restHelpers.withBearer.put(`${K.API_URL}/drivers/${uin}`, { data: { ...data } }),
  delete: (id) => restHelpers.withBearer.delete(`${K.API_URL}/drivers/${id}`, {})
};



// WEBPACK FOOTER //
// ./src/services/drivers.js